export const connectorObservable = 'CONNECTOR';
export const deletedField = 'isDeleted';
export const componentDestroyed = 'DESTROYED';
export const componentInitialized = 'INITIALIZED';
